import ScrollReveal from "../../../components/feature/ScrollReveal";
import { scheduleData } from "../../../mocks/flowData";

export default function ScheduleSection() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{scheduleData.label}</p>
              <h2 className="section-title">{scheduleData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="relative">
            <div className="hidden md:block absolute left-8 top-0 bottom-0 w-px bg-airdoa-gold/30" />

            <div className="flex flex-col gap-8">
              {scheduleData.items.map((item, idx) => (
                <ScrollReveal key={item.time} direction="up" delay={idx * 100}>
                  <div className="flex flex-col md:flex-row gap-4 md:gap-8">
                    <div className="flex items-center md:items-start gap-3 md:w-24 shrink-0">
                      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold shrink-0 z-10 border-4 border-airdoa-white">
                        <span className="text-xs font-bold">{item.time}</span>
                      </div>
                    </div>
                    <div className="flex-1 p-5 bg-airdoa-cream rounded-lg">
                      <h3 className="text-base font-serif font-semibold text-airdoa-navy">{item.title}</h3>
                      <p className="mt-2 text-sm text-airdoa-gray leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}